import buttonsTypes from './buttonsTypes';
import { EXCEPTIONS } from '../exceptions/ssapExceptions';


const DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME = {
    leftButton: buttonsTypes.CANCEL_BTN,
    middleButton: buttonsTypes.DEFAULT_BTN,
    rightButton: buttonsTypes.COMBINED_BTN
};

const ALL_BUTTONS_HIDDEN_SCHEME = {
    leftButton: buttonsTypes.HIDDEN_BTN,
    middleButton: buttonsTypes.HIDDEN_BTN,
    rightButton: buttonsTypes.HIDDEN_BTN,
};


/**************************************************

 # Buttons Schemas

 *************************************************/

export const BUTTONS_SCHEMES = {
    // Review Schemes for deleteButton, test after

    [EXCEPTIONS.EDITING_PRIMARY_HOUSEHOLD_CONTACT]: DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,

    [EXCEPTIONS.EDITING_HOUSEHOLD_MEMBER_ADDRESS]: DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,

    [EXCEPTIONS.EDITING_HOUSEHOLD_MEMBER]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addPersonButton: buttonsTypes.DEFAULT_BTN,
        deleteButton: buttonsTypes.DEFAULT_BTN,
        removeMemberButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.ADDING_HOUSEHOLD_MEMBER]: DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,

    [EXCEPTIONS.EDITING_INCOMES_AND_DEDUCTIONS]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addIncomeSourceButton: buttonsTypes.DEFAULT_BTN,
        editButton_secondary: buttonsTypes.DEFAULT_BTN,
        removeButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.REVIEW_INCOME_SECTION]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addIncomeSourceButton: buttonsTypes.DEFAULT_BTN,
        editButton_secondary: buttonsTypes.DEFAULT_BTN,
        removeButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.ADDING_HOUSEHOLD_MEMBER_FROM_HOUSEHOLD_SECTION]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addPersonButton: buttonsTypes.DEFAULT_BTN,
        deleteButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.REVIEW_BEFORE_SUBMIT]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addIncomeSourceButton: buttonsTypes.DEFAULT_BTN,
        editButton_secondary: buttonsTypes.DEFAULT_BTN,
        removeButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.REVIEW_BEFORE_SUBMIT_FAMILY_AND_HOUSEHOLD]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addIncomeSourceButton: buttonsTypes.DEFAULT_BTN,
        editButton_secondary: buttonsTypes.DEFAULT_BTN,
        removeButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.EDITING_ADDITIONAL_INFORMATION] : {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        editAdditionalInformationButton: buttonsTypes.DEFAULT_BTN,
        editButton_secondary: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.REVIEW_HOUSEHOLD_SECTION]: DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,

    [EXCEPTIONS.FIXING_TAX_RELATIONSHIP]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addPersonButton: buttonsTypes.DEFAULT_BTN,
        deleteButton: buttonsTypes.DEFAULT_BTN,
        removeMemberButton: buttonsTypes.DEFAULT_BTN
    },

    [EXCEPTIONS.REVIEW_AFTER_SIGN]: {
        ...ALL_BUTTONS_HIDDEN_SCHEME,
        editButton_secondary: buttonsTypes.HIDDEN_BTN,
        downloadButton: buttonsTypes.INITIAL_BTN,
        printButton: buttonsTypes.INITIAL_BTN
    },

    [EXCEPTIONS.MANAGE_SPOUSE]: {
        ...DEFAULT_BUTTONS_WITH_CANCEL_BUTTON_SCHEME,
        addPersonButton: buttonsTypes.DEFAULT_BTN,
        deleteButton: buttonsTypes.DEFAULT_BTN,
        removeMemberButton: buttonsTypes.DEFAULT_BTN
    }
};

const buttonsConfigs = {

    leftButton: {
        [buttonsTypes.HIDDEN_BTN]: {
            className: 'usa-button gi-button gi-button__primary',
            isShown: false,
            i18n: 'button.nothing'
        },
        [buttonsTypes.INITIAL_BTN]: {
            isShown: false,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.back'
        },

        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.back'
        },

        [buttonsTypes.CANCEL_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.cancel'
        }
    },

    middleButton: {
        [buttonsTypes.HIDDEN_BTN]: {
            className: 'usa-button gi-button gi-button__primary',
            isShown: false,
            i18n: 'button.nothing'
        },
        [buttonsTypes.DEFAULT_BTN]: {
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            isShown: true,
            i18n: 'button.save_exit'
        },
    },

    rightButton: {
        [buttonsTypes.COMBINED_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.save_continue'
        },
        [buttonsTypes.HIDDEN_BTN]: {
            isShown: false,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.nothing'
        },
        [buttonsTypes.INITIAL_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.continue'
        },

        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.continue'
        },

        [buttonsTypes.SWITCHED_TO_SAVE_BUTTON_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.continue'
        },

        [buttonsTypes.SWITCHED_TO_SUBMIT_APPLICATION_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.submit_application'
        }
    },

    addAddress: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.edit'
        },
    },

    editButton_secondary: {
        [buttonsTypes.HIDDEN_BTN]: {
            isShown: false,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.edit'
        },

        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline gi-button--small',
            i18n: 'button.edit'
        }
    },

    removeButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline gi-button--small',
            i18n: 'button.remove'
        }
    },

    removeMemberButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline gi-button--small',
            i18n: 'button.remove_member'
        }
    },

    addPersonButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.add_person'
        }
    },

    deleteButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.delete'
        }
    },

    addIncomeSourceButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary margin-top-null',
            i18n: 'button.add_income_source'
        }
    },

    addDeductionSourceButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary margin-top-null',
            i18n: 'button.add_deduction_source'
        }
    },

    addEmployerCoverageDetailButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.add_employer_coverage_detail'
        },
    },

    addHraDetailButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary',
            i18n: 'button.add_employer_coverage_detail'
        },
    },

    downloadButton: {
        [buttonsTypes.INITIAL_BTN]: {
            isShown: true,
            className: 'usa-button gi-button gi-button__primary gi-button--small',
            i18n: 'button.download'
        }
    },

    fixHouseholdMemberButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.fix_household_member'
        },
    },

    fixRelationshipButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.fix_relationship'
        },
        [buttonsTypes.SPOUSE_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.select_spouse'
        }
    },

    updateInformationButton: {
        [buttonsTypes.DEFAULT_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.update_information'
        },
        [buttonsTypes.SPOUSE_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline',
            i18n: 'button.add_spouse'
        }
    },

    printButton: {
        [buttonsTypes.INITIAL_BTN]: {
            isShown: true,
            className: 'usa-button usa-button--outline gi-button gi-button__outline gi-button--small',
            i18n: 'button.print'
        }
    },
};

export const getButtons = params => {

    const {
        exception,
        page,
        type,
        adjustedFlow,
        isJumpingRestricted,
        appSummaryPageIndex
    } = params;

    let buttonSubType;

    if(page === appSummaryPageIndex && type === 'editButton_secondary' && isJumpingRestricted) {
        buttonSubType = buttonsTypes.HIDDEN_BTN;
    } else {
        buttonSubType = adjustedFlow[page].page.buttons[type];
    }

    const {
        exceptionType,
        exceptionPages
    } = exception;


    let typeForException;

    if(page === exceptionPages[0]) {
        typeForException = BUTTONS_SCHEMES[exceptionType][type];
    } else {
        typeForException = buttonSubType;
    }

    const btn = exceptionType !== null ?
        buttonsConfigs[type] && buttonsConfigs[type][typeForException] :
        buttonsConfigs[type] && buttonsConfigs[type][buttonSubType];

    if(!btn) {

        // For FallBack UI in Development. Here we return false if we weren't successful to get Button config

        return {
            className: 'lost-button',
            isShown: true,
            i18n: 'button.lost'
        };
    }

    return {
        className: btn.className,
        isShown: btn.isShown,
        i18n: btn.i18n
    };
};
